import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { SECTIONS, reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import ExcelExportButton from '../common/excelExportButton';
import HistoryLink from '../common/historyLink';
import BbCollapse from '../common/BbCollapse';
import OldStyleSubsection from '../common/oldStyleSubsection';
import BbPopover from '../common/popover';

class WarningData extends React.Component {
    state = {
        collapse: false,
        historyExpanded: false,
        isHistoryExpandedTouched: false
    };


    render() {
        const { data, isLimited } = this.props;
        return (isNullOrUndefined(data) ? null : this.renderContent(data, isLimited));
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isHistoryExpandedTouched: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.state.collapse !== nextState.collapse || this.state.historyExpanded !== nextState.historyExpanded ||
            this.props.isExpandAllActivated !== nextProps.isExpandAllActivated || this.props.isHideAllActivated !== nextProps.isHideAllActivated;
    }

    renderContent = (data, isLimited) => {
        const withFullIdentification = this.endsWith(this.props.location, '/WarningData');
        var subsections = this.props.sections.filter(s => s.id === this.props.sectionId)[0].subsections;
        let isMirriReport = this.props.sectionId === SECTIONS.mirriWarningData;

        return (
            <div>
                {this.filterGroupData(data.groups)}

                {subsections.map(s => <OldStyleSubsection isBold
                    key={s.id}
                    sectionId={this.props.sectionId}
                    subsectionId={s.id}
                    subsectionName={this.props.translate(s.name)}
                    subsectionData={{ type: s.params.type }}
                />)}
        
                <ExcelExportButton link={isMirriReport ? "mirri-warnings" : "warnings"} entityId={this.props.id} report={this.props.reportType} additionalParams={{ withFullIdentification: withFullIdentification }}/>
            </div>
        );
    }

    toggle = () => {
        this.setState(state => ({ collapse: !state.collapse }));
    }

    filterGroupData = (groups) => {
        if(groups === undefined || groups === null || groups.length === 0) {
            return '';
        }

        let actualWarningsToRender = [];
        let historicalWarningsToRender = [];
        groups.filter(f => f.display === true && f.items !== null && f.items !== undefined).forEach(x => {
            x.items.filter(i => i.code !== null).forEach(i => i.code > 0 ? actualWarningsToRender.push(i) : historicalWarningsToRender.push(i));
        });

        if(actualWarningsToRender.length === 0 && historicalWarningsToRender.length === 0) {
            return '';
        }

        if(actualWarningsToRender.length === 0 && historicalWarningsToRender.length !== 0) {
            return (
                <div style={{paddingBottom:"0.1em", display:'flex', flex:'1 0 auto'}}>
                    <div className="warning-root">
                        <div style={{display:'flex'}}>{historicalWarningsToRender.map(g => this.renderGroupItem(g))}</div>
                    </div>
                </div>
            );
        }

        return (
            <div style={{paddingBottom:"0.1em", display:'flex', flex:'1 0 auto'}}>
                <div className="warning-root">
                    <div style={{display:'flex', flex:'1 1 auto'}}>
                        {actualWarningsToRender.length === 0 ? <span className="no-actual-data"><Translate id="Report.Common.NoActualData" /></span> : actualWarningsToRender.sort(function(a,b){return a.code == b.code ? 0 : a.code < b.code ? 1 : -1;}).map(g => this.renderGroupItem(g))}
                    </div>
                    { historicalWarningsToRender.length !== 0 && <BbCollapse className="flex" isOpen={this.props.resolveExpanded(this.state.historyExpanded, this.state.isHistoryExpandedTouched)}>
                        {historicalWarningsToRender.map(g => this.renderGroupItem(g))}
                    </BbCollapse> }
                </div>
                { historicalWarningsToRender.length !== 0 && <div className="history-link-box" style={{flex:'none', display:'flex', paddingRight:'.75em'}}>
                        <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.historyExpanded, this.state.isHistoryExpandedTouched)}
                            onClick={this.toggleHistory}
                        />
                    </div>}
            </div>
        );
    }

    warningClassName = (profiMode, code) => {
        return 'warn-status-' + (profiMode ? "profi-" :"") + ((code === null || code === undefined) ? "NA" : code);
    }

    renderGroupItem = (item) => {
        return (
            <div key={item.id} className={this.warningClassName(true, item.code)}>
                <div className="hide-on-mobile" title={item.description}>
                    <div style={{fontSize: (item.name.length > 3) ? "0.8em" : ""}}>
                        {item.name}
                    </div>
                </div>
                <div className="hide-on-desktop">
                    <BbPopover
                        content={item.description}
                        placement="top"
                        targetId={`group-item-${item.id}`}
                    >
                            <div id={`group-item-${item.id}`} style={{fontSize: (item.name.length > 3) ? "0.8em" : ""}}>
                                {item.name}
                            </div>
                    </BbPopover> 
                </div>
            </div>
        );
    }

    toggleHistory = () => {
        this.setState({
            historyExpanded: !this.props.resolveExpanded(this.state.historyExpanded, this.state.isHistoryExpandedTouched),
            isHistoryExpandedTouched: true
        });
    }

    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(WarningData));
